import React from "react";
import { LinkToNode } from "components/common";
import {
  calculateInputMetricsByNode,
  getInputConnectionMetrics,
  formatCount
} from "components/inputs/helpers/InputThroughputUtils";
import { Connections, NetworkIOStats } from "components/inputs/InputsOveriew";
const NodeMetricsDetails = ({ input, metrics }) => {
  const calculatedMetricsByNode = calculateInputMetricsByNode(input, metrics);
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("hr", null), Object.keys(calculatedMetricsByNode).map((nodeId) => {
    const {
      openConnections,
      totalConnections,
      emptyMessages,
      writtenBytes1Sec,
      writtenBytesTotal,
      readBytes1Sec,
      readBytesTotal
    } = getInputConnectionMetrics(input, calculatedMetricsByNode[nodeId] || {});
    return /* @__PURE__ */ React.createElement("span", { key: input.id + nodeId }, /* @__PURE__ */ React.createElement(LinkToNode, { nodeId }), /* @__PURE__ */ React.createElement("br", null), !isNaN(writtenBytes1Sec) && /* @__PURE__ */ React.createElement(
      NetworkIOStats,
      {
        writtenBytes1Sec,
        writtenBytesTotal,
        readBytes1Sec,
        readBytesTotal
      }
    ), /* @__PURE__ */ React.createElement("br", null), !isNaN(openConnections) && /* @__PURE__ */ React.createElement(Connections, { openConnections, totalConnections }), !isNaN(emptyMessages) && /* @__PURE__ */ React.createElement("span", null, "Empty messages discarded: ", formatCount(emptyMessages), /* @__PURE__ */ React.createElement("br", null)), isNaN(writtenBytes1Sec) && isNaN(openConnections) && /* @__PURE__ */ React.createElement("span", null, "No metrics available for this node"));
  }));
};
export default NodeMetricsDetails;
